import * as types from './actionTypes'

const initialState = {
  showAuthPopup: undefined,
}

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_LOGIN_FORM:
      return {
        ...state,
        showAuthPopup: action.data,
      }
    case types.HIDE_LOGIN_FORM:
      return {
        ...state,
        showAuthPopup: undefined,
      }
    case types.SHOW_BUSINESS_FORM:
      return {
        ...state,
        showBusinessForm: action.isEdit ? 1 : true,
      }
    case types.HIDE_BUSINESS_FORM:
      return {
        ...state,
        showBusinessForm: false,
      }
    case types.SHOW_FAVORITE_BADGE:
      return {
        ...state,
        showFavoriteBadge: true,
      }
    case types.HIDE_FAVORITE_BADGE:
      return {
        ...state,
        showFavoriteBadge: false,
      }
    default:
      return state
  }
}

export default uiReducer
